<template>
  <div class="max-w-md mx-auto my-16 px-5 flex flex-col items-center">
    <lm-loading v-if="state === States.VALIDATING_TOKEN" />
    <p v-else-if="state === States.TOKEN_ERROR" class="text-center">
      <span class="block mb-4 text-error font-medium">{{ errorMessage }}</span>
      <router-link :to="{name: 'login'}" class="text-gray-900 underline"
        >Go to Login</router-link
      >
    </p>
    <template v-else-if="state === States.TOKEN_OK">
      <dark-logo class="block w-20 h-20 mx-auto mb-8" />
      <lm-title class="mb-4 text-center">
        <strong>{{ adminName }}</strong> has invited you to
        <strong>{{ landscapeName }}</strong>
      </lm-title>
      <p class="mb-12 text-center text-gray-700">
        Join Landscape Monitor to view the invitation
      </p>
      <form class="max-w-xs">
        <lm-input ref="email" type="email" label="Email" disabled />
        <LmInput
          ref="pass"
          type="password"
          label="Password"
          :maxlength="0"
          custom-rule="loginPassword"
          focus
        />
        <lm-legal-checkbox ref="legal" v-model="checkLegal" class="mb-12" />
        <lm-button
          class="w-full"
          type="primary"
          :loading="submitting"
          @click.prevent="submit"
        >
          Sign up
        </lm-button>
      </form>
    </template>
  </div>
</template>

<script>
import LmInput from '@/components/form/LmInput'
import LmLegalCheckbox from '@/components/form/LmLegalCheckbox'
import DarkLogo from '@/components/ui/DarkLogo'
import LmButton from '@/components/ui/LmButton'
import LmLoading from '@/components/ui/LmLoading'
import LmTitle from '@/components/ui/text/LmTitle'
import auth from '@/lib/auth'
import {Alert, AlertMessages} from '@/lib/definitions'
import {newAlert} from '@/lib/eventHub'
import axios from 'axios'

const States = {
  VALIDATING_TOKEN: 'validating',
  TOKEN_ERROR: 'error',
  TOKEN_OK: 'tokenOk'
}

export default {
  name: 'InvitationView',
  components: {
    LmLoading,
    LmLegalCheckbox,
    LmButton,
    LmTitle,
    DarkLogo,
    LmInput
  },
  data() {
    return {
      adminName: null,
      userEmail: null,
      landscapeName: null,
      landscapeSlug: null,
      submitting: false,
      checkLegal: false,
      errorMessage: 'Invalid token',
      state: States.VALIDATING_TOKEN,
      States
    }
  },
  mounted() {
    this.validateToken()
  },
  methods: {
    validateToken() {
      const params = this.$route.query
      if (params.t) {
        axios
          .get(process.env.VUE_APP_API_URL + '/invitation/' + params.t)
          .then(res => {
            this.state = States.TOKEN_OK
            const data = res.data.response
            this.adminName = data.admin.username
            this.landscapeName = data.landscape.name
            this.landscapeSlug = data.landscape.slug
            this.userEmail = data.email
            this.$nextTick(() => {
              this.$refs.email.setData(data.email)
            })
          })
          .catch(error => {
            this.state = States.TOKEN_ERROR
            const e = error.response.data.response
            if (e.devCode === 409) {
              this.errorMessage =
                'Error: This user already exists. Please login'
            }
          })
      } else {
        this.state = States.TOKEN_ERROR
        this.errorMessage = 'Error: Invitation token not present'
      }
    },
    submit() {
      this.submitting = true
      let valid = true
      for (let ref in this.$refs) {
        if (!this.$refs[ref].validateData()) {
          valid = false
        }
      }
      if (valid) {
        const data = {
          type: 'trial',
          email: this.userEmail,
          username: this.userEmail.substring(0, this.userEmail.indexOf('@')),
          password: this.$refs.pass.data,
          acceptPolicy: true,
          subscribed: false
        }
        axios
          .post(process.env.VUE_APP_API_URL + '/users/signup', data)
          .then(() => {
            const backTo = process.env.VUE_APP_DOMAIN
            auth.auth0.redirect.loginWithCredentials(
              {
                connection: 'Username-Password-Authentication',
                username: this.userEmail,
                password: this.$refs.pass.data,
                state: backTo,
                scope: 'openid state'
              },
              error => {
                this.showError(
                  AlertMessages.LOGIN_ERROR + ' ' + error.description
                )
              }
            )
          })
          .catch(error => {
            this.showError(error.response.data.response.devMessage)
          })
      } else {
        this.submitting = false
      }
    },
    showError(msg) {
      newAlert(msg, Alert.ERROR, false)
      this.submitting = false
    }
  }
}
</script>
